import {
    Backdrop,
    Button,
    CircularProgress,
    Fade,
    Grid,
    IconButton,
    Modal,
    Paper,
} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {useState} from 'react';
import {isObject} from 'utils/objects';
import {CircleInfoPopout} from './icons/icons';
import {P} from 'components/TypographyShortcuts';

const useStyles = makeStyles(theme => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        outline: 'none',
    },
    paper: {
        padding: '1rem',
        margin: 'auto',
        maxWidth: 1000,
    },
}));

const SubmitStatusButton = ({
    children,
    text = 'Submit',
    variant = 'contained',
    color = 'primary',
    onClick = () => {},
    disabled = false,
    inProgress = false,
    success = false,
    successText = 'Success!',
    error = false,
    errorText = 'Error!',
}) => {
    return (
        <Button
            variant={variant}
            color={success || error ? 'default' : color}
            onClick={onClick}
            disabled={disabled || inProgress || success || error}
        >
            {inProgress ? (
                <CircularProgress />
            ) : success ? (
                successText
            ) : error ? (
                errorText
            ) : (
                children || text
            )}
        </Button>
    );
};

const InfoModalGridItem = ({children}) => {
    const classes = useStyles();

    const [open, setOpen] = useState(false);
    if (children) {
        return (
            <Grid item>
                <IconButton
                    variant='extended'
                    edge='end'
                    size='small'
                    color='secondary'
                    onClick={() => setOpen(true)}
                >
                    <CircleInfoPopout />
                </IconButton>
                <Modal
                    open={open}
                    className={classes.modal}
                    onClose={() => setOpen(false)}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{timeout: 500}}
                >
                    <Fade in={open}>
                        <Paper className={classes.paper}>{children}</Paper>
                    </Fade>
                </Modal>
            </Grid>
        );
    } else {
        return null;
    }
};

// TODO - extend for more posibilities. this will probably break
const ComponentFromWhatever = ({data}) => {
    if (isObject(data)) {
        return <pre>{JSON.stringify(data, null, 2)}</pre>;
    } else {
        return <P>{data}</P>;
    }
};

const SubmitStatusButtonInfo = ({infoMessage = '', ...rest}) => {
    return (
        <Grid container spacing={2}>
            <Grid item>
                <SubmitStatusButton {...rest} />
            </Grid>
            <InfoModalGridItem>
                <ComponentFromWhatever data={infoMessage} />
            </InfoModalGridItem>
        </Grid>
    );
};

export default SubmitStatusButton;
export {SubmitStatusButtonInfo};
